/** Navigation label keys for i18n (see i18n/locales/*.json nav.*). */
export const MENUS = [
  {
    labelKey: "nav.operations",
    items: [
      { labelKey: "nav.pointOfSale", to: "/pos", permission: "pos.view" },
      { labelKey: "nav.invoiceHistory", to: "/pos/invoice-history", permission: "pos.view" },
      { labelKey: "nav.quotations", to: "/pos/quotations", permission: "pos.view" },
      { labelKey: "nav.salesReturns", to: "/pos/sales-returns", permission: "pos.view" },
      { labelKey: "nav.heldBills", to: "/pos/held-bills", permission: "pos.view" },
    ],
  },
  {
    labelKey: "nav.online",
    items: [
      {
        labelKey: "nav.onlineOrders",
        to: "/online/orders",
        accessCheck: (p) => p.includes("pos.view") || p.includes("masters.view"),
      },
      {
        labelKey: "nav.onlineHistory",
        to: "/online/history",
        accessCheck: (p) => p.includes("pos.view") || p.includes("masters.view"),
      },
    ],
  },
  {
    labelKey: "nav.masters",
    items: [
      { labelKey: "nav.categories", to: "/masters/categories", permission: "masters.view" },
      { labelKey: "nav.products", to: "/masters/products", permission: "masters.view" },
      { labelKey: "nav.brands", to: "/masters/brands", permission: "masters.view" },
      { labelKey: "nav.shelves", to: "/masters/shelves", permission: "masters.view" },
      { labelKey: "nav.areas", to: "/masters/areas", permission: "masters.view" },
      { labelKey: "nav.units", to: "/masters/units", permission: "masters.view" },
      { labelKey: "nav.customers", to: "/masters/customers", permission: "masters.view" },
      { labelKey: "nav.suppliers", to: "/masters/suppliers", permission: "masters.view" },
      { labelKey: "nav.priceChanges", to: "/masters/price-changes", permission: "masters.view" },
      { labelKey: "nav.barcodeLabels", to: "/masters/barcode-labels", permission: "masters.view" },
      { labelKey: "nav.privilegeCards", to: "/masters/privilege-cards", permission: "masters.view" },
    ],
  },
  {
    labelKey: "nav.inventory",
    items: [
      { labelKey: "nav.inventoryHub", to: "/inventory", permission: "inventory.view" },
      { labelKey: "nav.stockSummary", to: "/inventory/stock", permission: "inventory.view" },
      { labelKey: "nav.purchaseRequests", to: "/inventory/purchase-requests", permission: "inventory.view" },
      { labelKey: "nav.purchaseOrders", to: "/inventory/purchase-orders", permission: "inventory.view" },
      { labelKey: "nav.grn", to: "/inventory/grn", permission: "inventory.view" },
      { labelKey: "nav.purchaseDebitNotes", to: "/inventory/purchase-debit-notes", permission: "inventory.view" },
      { labelKey: "nav.transfers", to: "/inventory/transfers", permission: "inventory.view" },
      { labelKey: "nav.adjustments", to: "/inventory/adjustments", permission: "inventory.view" },
      { labelKey: "nav.openingPhysical", to: "/inventory/opening", permission: "inventory.view" },
      { labelKey: "nav.wastage", to: "/inventory/wastage", permission: "inventory.view" },
      { labelKey: "nav.supplierReturns", to: "/inventory/returns", permission: "inventory.view" },
      { labelKey: "nav.inventoryAlerts", to: "/inventory/alerts", permission: "inventory.view" },
    ],
  },
  {
    labelKey: "nav.accounts",
    items: [
      { labelKey: "nav.schedules", to: "/accounts/schedules", permission: "accounts.view" },
      { labelKey: "nav.accountsChart", to: "/accounts/accounts", permission: "accounts.view" },
      { labelKey: "nav.receiptVoucher", to: "/accounts/receipt", permission: "accounts.view" },
      { labelKey: "nav.paymentVoucher", to: "/accounts/payment", permission: "accounts.view" },
      { labelKey: "nav.journalVoucher", to: "/accounts/journal", permission: "accounts.view" },
      { labelKey: "nav.contraVoucher", to: "/accounts/contra", permission: "accounts.view" },
      { labelKey: "nav.debitNote", to: "/accounts/debit-note", permission: "accounts.view" },
      { labelKey: "nav.creditNote", to: "/accounts/credit-note", permission: "accounts.view" },
      { labelKey: "nav.ledgerReport", to: "/accounts/ledger", permission: "accounts.view" },
      { labelKey: "nav.trialBalance", to: "/accounts/trial-balance", permission: "accounts.view" },
      { labelKey: "nav.profitLoss", to: "/accounts/profit-loss", permission: "accounts.view" },
      { labelKey: "nav.balanceSheet", to: "/accounts/balance-sheet", permission: "accounts.view" },
      { labelKey: "nav.cashBook", to: "/accounts/cash-book", permission: "accounts.view" },
      { labelKey: "nav.bankBook", to: "/accounts/bank-book", permission: "accounts.view" },
      { labelKey: "nav.dayBook", to: "/accounts/day-book", permission: "accounts.view" },
      { labelKey: "nav.accountingSettings", to: "/accounts/settings", permission: "accounts.view" },
    ],
  },
  {
    labelKey: "nav.reports",
    items: [
      { labelKey: "nav.reportCenter", to: "/reports", permission: "reports.view" },
      { labelKey: "nav.misReports", to: "/reports/mis", permission: "reports.view" },
    ],
  },
  {
    labelKey: "nav.administration",
    items: [
      { labelKey: "nav.users", to: "/admin/users", permission: "administration.view" },
      { labelKey: "nav.roles", to: "/admin/roles", permission: "administration.view" },
      { labelKey: "nav.auditLog", to: "/admin/audit-log", permission: "administration.view" },
      { labelKey: "nav.counters", to: "/admin/counters", permission: "administration.view" },
      { labelKey: "nav.printers", to: "/admin/printers", permission: "administration.view" },
      { labelKey: "nav.denominations", to: "/admin/denominations", permission: "administration.view" },
      { labelKey: "nav.companySetup", to: "/admin/company", permission: "administration.view" },
      { labelKey: "nav.storeSetup", to: "/admin/store", permission: "administration.view" },
      { labelKey: "nav.taxSettings", to: "/admin/tax", permission: "administration.view" },
      { labelKey: "nav.generalSettings", to: "/admin/general", permission: "administration.view" },
      { labelKey: "nav.onlineStore", to: "/admin/online-store", permission: "administration.view" },
    ],
  },
];
